module.exports = __webpack_public_path__ + "img/fuwu.4d779b90.jpg";